<template>
  <Modal :show="true" @close-modal="$emit('show-member-form', false)">
    <div class="add-member-modal">
      <button class="close-btn" @click="$emit('show-member-form', false)">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="modal-header">
        <div class="modal-header__icon">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6667 19.25V17.4167C14.6667 16.4442 14.2804 15.5116 13.5927 14.8239C12.9051 14.1363 11.9725 13.75 11 13.75H4.58333C3.61087 13.75 2.67824 14.1363 1.99061 14.8239C1.30298 15.5116 0.916664 16.4442 0.916664 17.4167V19.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.79167 10.0833C9.81671 10.0833 11.4583 8.44171 11.4583 6.41667C11.4583 4.39162 9.81671 2.75 7.79167 2.75C5.76662 2.75 4.125 4.39162 4.125 6.41667C4.125 8.44171 5.76662 10.0833 7.79167 10.0833Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.3333 7.33333V12.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21.0833 10.0833H15.5833" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h1 class="modal-header__title">Add member</h1>
      </div>

      <form class="add-member-form" @submit.prevent="sendInvite">
        <div class="form-group">
          <label class="form-label">Search for member</label>
          <div class="search-input-wrapper">
            <svg class="search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.75 15.75L12.4875 12.4875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input
              type="text"
              class="search-input"
              placeholder="Type a name to search..."
              :value="memberName"
              @input="findMember({ value: $event.target.value })"
            />
          </div>

          <div v-show="showMembersResult && members.length" class="member-results">
            <div
              class="member-result-item"
              @click="setMember(member)"
              v-for="member in members"
              :key="member._id"
            >
              <div class="member-avatar">
                {{ (member.fname?.charAt(0) || '') + (member.lname?.charAt(0) || '') }}
              </div>
              <span class="member-name">{{ member.fname + " " + member.lname }}</span>
            </div>
          </div>
        </div>

        <button type="submit" class="submit-btn" :disabled="loading || !member">
          <span v-if="!loading">Add member</span>
          <svg v-else class="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 15V18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
            <path d="M4.10831 4.10834L6.28331 6.28334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.7167 13.7167L15.8917 15.8917" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
            <path d="M2 10H5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15 10H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
          </svg>
        </button>
      </form>
    </div>
  </Modal>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import Modal from "@/components/general/Modal";
  
  export default {
    name: "AddMemberModal",
    
    components: {
      Modal,
    },
    
    emits: ["show-member-form"],
    
    data() {
      return {
        memberName: null,
        showMembersResult: false,
        loading: false,
        member: "",
      };
    },
    
    computed: {
      ...mapGetters("TokenModule", ["members", "token"]),
    },
    
    watch: {
      members() {
        this.showMembersResult = true;
      },
    },
    
    methods: {
      ...mapActions("TokenModule", [
        "fetchMemberByName",
        "inviteMember",
        "getDealMembers",
      ]),
      ...mapActions(["showToast"]),
      
      async findMember(obj) {
        const name = obj.value;
        this.memberName = name;
        if (name.length !== 0) {
          try {
            await this.fetchMemberByName(name);
          } catch (error) {
            return error;
          }
        }
      },
      
      setMember(member) {
        this.memberName = `${member.fname} ${member.lname}`;
        this.member = member._id;
        this.showMembersResult = false;
      },
      
      async sendInvite() {
        const members = [this.member];
        this.loading = true;
        const url = window.location.host.includes("getequity.io")
          ? "https://app.getequity.io/dashboard/deal-room"
          : "https://staging--getequityinvestors.netlify.app/dashboard/deal-room";
        try {
          const response = await this.inviteMember({
            members,
            id: this.token.token,
            url,
          });
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.loading = false;
          this.getDealMembers(this.token.token);
          this.$emit("show-member-form", false);
        } catch (error) {
          this.loading = false;
          return error;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.add-member-modal {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.12);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #F8FAFC;
  border: none;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #F1F5F9;
    color: #0F172A;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: #EEF2FF;
    border-radius: 10px;
    color: #4D84FF;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0;
  }
}

.add-member-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  position: relative;
}

.form-label {
  display: block;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 14px;
  color: #94A3B8;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 12px 14px 12px 44px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #0F172A;
  transition: all 0.2s ease;

  &::placeholder {
    color: #94A3B8;
  }

  &:focus {
    outline: none;
    border-color: #4D84FF;
    background: white;
  }
}

.member-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.member-result-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #F8FAFC;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #F1F5F9;
  }
}

.member-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
  border-radius: 50%;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
}

.member-name {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #0F172A;
}

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 20px;
  background: #4D84FF;
  border: none;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #3B6EE8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
